module.exports = __webpack_public_path__ + "static/media/user-hex-with-back.6cef2cc6.svg";